/* @format */

import LocalStorageService from '@tenant/app/services/LocalStorageService';

export default {
    methods: {
        _showHotelsAllInclusivePricingInfo: function (hotels) {
            const allInclusiveHotel = hotels.find((hotel) => {
                const { allInclusivePricingNotification, address } = hotel;
                const { countryCode, stateCode } = address;

                return (
                    allInclusivePricingNotification &&
                    !LocalStorageService.allInclusivePricing.has(countryCode, stateCode)
                );
            });
            if (allInclusiveHotel) {
                const { countryCode, stateCode } = allInclusiveHotel.address;
                const i18nPrefix =
                    'main:views.eventV2.theEvent._components.allInclusivePricingConfirmModal';

                this.$modal.show(
                    () => import('@tenant/app/components/modals/ConfirmationModal'),
                    {
                        title: this.$t(`${i18nPrefix}.title`),
                        content: this.$t(`${i18nPrefix}.content`),
                        confirmButton: this.$t(`${i18nPrefix}.button`),
                        onConfirmFn: () => {
                            LocalStorageService.allInclusivePricing.add(countryCode, stateCode);
                        },
                    },
                    {
                        'max-width': 858,
                        persistent: true,
                    }
                );
            }
        },
    },
};
